import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { HiOutlineUserCircle } from "react-icons/hi";
import "./Register.css";

const Register = () => {
  // handle the register form submit
  const handleRegisterForm = (e) => {
    e.preventDefault();
  };
  return (
    <div className="register-container">
      <div className="register">
        {/* <div className="type">
          <i>
            <HiOutlineUserCircle size={70} />
          </i>
        </div> */}
        <form className="register-form" onSubmit={handleRegisterForm}>
          <div className="input">
            <input
              type="email"
              placeholder="Enter your Email"
              className="register-input"
            />
          </div>
          <div className="input">
            <input
              type="tel"
              placeholder="Enter your mobile number"
              className="register-input"
            />
          </div>
          <div className="input">
            <input
              type="password"
              placeholder="Password"
              className="register-input"
            />
          </div>
          <div className="input">
            <input
              type="password"
              placeholder="Confirm Password"
              className="register-input"
            />
          </div>
          <button type="submit" id="register-btn">
            Register
          </button>
          <p id="reg-text">
            New to OkoaPatient? <Link to="/login">Login</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
